import { render, staticRenderFns } from "./partitionTrade.vue?vue&type=template&id=925eccf6&scoped=true&"
import script from "./partitionTrade.vue?vue&type=script&lang=js&"
export * from "./partitionTrade.vue?vue&type=script&lang=js&"
import style0 from "./partitionTrade.vue?vue&type=style&index=0&id=925eccf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925eccf6",
  null
  
)

export default component.exports